import { withStyles } from '@material-ui/core';
import { OptionSelector as DaySelection } from '../../../../common/MUI';
import { SELECTION_MODES } from '../../../../common/MUI/OptionSelector/constants';
import { weekdaysShortName } from '../../../Settings/Optimization/AnchorPoint/addUpdateAnchorPoint/DayOfWeekStatus/Constants';

const styles = (_theme) => ({
  daySelectionFilter: {
    minWidth: 28
  }
});

const DaySelectionFilter = ({ classes, handleFilterChange }) => {
  const dayOptions = [
    ...Object.entries(weekdaysShortName).map(([value, label]) => ({
      value,
      label
    })),
    { value: 'none', label: 'N/A' }
  ];
  return (
    <DaySelection
      title="Filter by Day:"
      options={dayOptions}
      selectionMode={SELECTION_MODES.MULTIPLE}
      onChange={handleFilterChange}
      customClass={classes.daySelectionFilter}
    />
  );
};

export default withStyles(styles)(DaySelectionFilter);
